import { Component, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import swal from 'sweetalert2';
import { ExcelService } from 'src/app/core/services/excel.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delai-execution',
  templateUrl: './delai-execution.component.html',
  styleUrls: ['./delai-execution.component.css'],
})
export class DelaiExecutionComponent implements OnInit {
  organisation: string;
  effectue_date: any;
  accepte_date: any;
  valide_date: any;
  approuve_date: any;
  showExecution = false;
  executions: any;
   key = 'code';
  reverse = false;
  p = 1;
  filter: string;
  month: any;
  day: any;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  constructor(
    private _service: AppService,
    private _loader: LoadingBarService,
    private toastrService: ToastrService,
    private _excelService: ExcelService,
    private _router: Router,
    private storage: LocalStorageService
  ) { }

  ngOnInit() {
    this.getDateOfDay();
  }


  getDateOfDay() {
    const d = new Date();
    const day = d.getDate();
    const month = d.getMonth() + 1;
    this.month = month;
    day < 10 ? this.day = '0' + day : this.day = day;
    month < 10 ? this.month = '0' + month : this.month = month;
    const year = d.getFullYear();
    this.effectue_date = year + '-' + this.month + '-' + this.day;
    this.valide_date = year + '-' + this.month + '-' + this.day;
    this.accepte_date = year + '-' + this.month + '-' + this.day;
    this.approuve_date = year + '-' + this.month + '-' + this.day;
  }

  exporterFiche() {
    this._loader.start();
    const arrayDelaiExecution = [];
    for (let i = 0; i < this.executions.length; i++) {
      arrayDelaiExecution.push(
        {
          'Organisation': this.executions[i].code,
          'Effectué': this.executions[i].effectue,
          'Accepté': this.executions[i].accepte,
          'Validé': this.executions[i].valide,
          'Approuvé': this.executions[i].approuve,
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayDelaiExecution, 'delai_execution');
    this._loader.stop();
  }

  rechercher() {
    this._loader.start();
    const obj = {
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
      type_organisation: this.organisation,
      delai_effectue: this.effectue_date,
      delai_accepte: this.accepte_date,
      delai_valide: this.valide_date,
      delai_approuve: this.approuve_date,
    };
    console.log(obj);
    this._service.postData('reporting/delai-execution', obj).subscribe(
      (res) => {
        if (res.error === false) {
          this._loader.stop();
          console.log(res);
          this.executions = res.data;
          this.showExecution = true;
        } else {
          swal.fire({
            title: 'HR PERF',
            type: 'warning',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          });
          this._loader.stop();
          this.showExecution = false;
        }
      },
      (err) => {
        this.toastrService.error(err.error.message);
        this._loader.stop();
        this.showExecution = false;
      }
    );
  }
}
